var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"shrink":""}},[_c('ProjectMainCard',{attrs:{"project":_vm.project,"recordCache":_vm.recordCache}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }